import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 21h18","key":"svg-0"}],["path",{"d":"M9 12h1","key":"svg-1"}],["path",{"d":"M9 16h1","key":"svg-2"}],["path",{"d":"M14 8h1","key":"svg-3"}],["path",{"d":"M14 16h1","key":"svg-4"}],["path",{"d":"M5 21v-16","key":"svg-5"}],["path",{"d":"M7 3h10c1 0 2 1 2 2v10","key":"svg-6"}],["path",{"d":"M19 19v2","key":"svg-7"}],["path",{"d":"M3 3l18 18","key":"svg-8"}]]

const IconBuildingOff = createReactComponent('outline', 'building-off', 'BuildingOff', __iconNode);

export default IconBuildingOff;